export interface IsFinishedState {
  finished: boolean;
  success: boolean;
  loaded: boolean;
}

export const initialFinishedState: IsFinishedState = {
  finished: false,
  success: false,
  loaded: false
};



// WEBPACK FOOTER //
// ./src/requestProgress/types.ts